import { useQuery } from '@tanstack/react-query'

import { parentApi } from '~/@common/api/parentApi'

/** 학생 출석 리스트 조회 (날짜 범위, yyyy-MM-dd). */
export const useStudentAttendances = (
  studentId: string | null | undefined,
  startDate: string,
  endDate: string,
) =>
  useQuery({
    queryKey: ['student-attendances', studentId, startDate, endDate],
    queryFn: () => parentApi.getAttendances(studentId as string, startDate, endDate),
    enabled: !!studentId,
    staleTime: 0,
  })
